import { render, staticRenderFns } from "./ConsentsPage.vue?vue&type=template&id=a0987fe8&"
import script from "./ConsentsPage.vue?vue&type=script&lang=js&"
export * from "./ConsentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports